// Ubah nomor WhatsApp di sini (format internasional tanpa tanda +, contoh: 6281234567890)
export const WHATSAPP_NUMBER = "6281234567890";

export const BRAND = {
  name: "Samsi Madu",
  tagline: "Madu Murni dari Tanah Jombang",
  location: "Jombang, Jawa Timur",
  email: "halo@samsimadu.id",
};

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message || "Halo Samsi Madu, saya ingin bertanya tentang produk madu.")}`;
